import { primaryColors } from "theme/themes";
import { SvgSexIntro } from "components/Images/sex";
import steps from "./steps";


const sex = {
  id: 'sex',
  title: "Sex",
  path: "/sex",
  description: "Meet Jaime and Amari as they navigate sex in their relationship",
  backgroundColor: primaryColors.teal,
  theme: "teal",
  intro: {
    backgroundImage: SvgSexIntro,
    backgroundImageWidth: '50%',
    text: "<p>This is the story of Jamie and Amari. They are high school students who have been together for a few months. Up until this point, they’ve been physically intimate—including hooking up, rubbing, stroking and touching.</p><p>They are at a two-day music festival with a bunch of friends. They have set up a tent nearby.</p>"
  },
  finalStepLearnmore: {
    title: "Where to find help 👋",
    content: '<p>Being in a relationship can be an exciting and special time. It can be enjoyable spending time with your partner, getting to know them and experiencing new feelings. For more information about consent, sex and respectful relationships visit the relationships page on the <a href="https://bodytalk.org.au/relationships/" target="_blank">Body Talk website</a></p><p>If you or someone you know is in immediate danger and require assistance, please call &rsquo;000&rsquo;.</p><p>If you have any questions, or you just need to talk to someone then check out the links below. They are all confidential &ndash; that means you don&rsquo;t have to tell anyone who you are and they won&rsquo;t tell anyone that you have contacted them.</p><p><a href="https://bodytalk.org.au/contact-us/" target="_blank">Family Planning NSW Talkline 1300 658 886</a><br /><a href="https://kidshelpline.com.au/teens" target="_blank">Kids Help Line - 1800 551 800</a><br /><a href="https://www.lifeline.org.au/" target="_blank">Lifeline - 13 1114</a><br /><a href="https://mensline.org.au/" target="_blank">Mensline Australia - Men and Boys support</a><br /><a href="https://fullstop.org.au/" target="_blank">Full Stop Australia - Sexual assault support</a><br /><a href="https://relationships.org.au/" target="_blank">Relationships Australia</a></p>'
  },
  finalStepThankYou: {
    title:"Thanks for participating!",
    content: "<p>It is good to remember that our experiences are what shape us, and our actions can have either positive or negative impacts on our life and the lives of others.</p>"
  }
  ,
  firstStepId: 'sex-1',
  steps: steps
};

export default sex;
